require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2017-10-memory-lane.json") })
        }
      }, "path---articles-2017-10-memory-lane");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2017-10-memory-lane!./.cache/json/articles-2017-10-memory-lane.json
// module id = 386
// module chunks = 231608221292675